import { Position, TBoardRow, TBoard } from "../types";
import { makeDarkSquare, makeLightSquare } from "../utils";

const makeEvenRow = (positions: Position[]): TBoardRow => [
  makeLightSquare(positions[0]),
  makeDarkSquare(positions[1]),
  makeLightSquare(positions[2]),
  makeDarkSquare(positions[3]),
  makeLightSquare(positions[4]),
  makeDarkSquare(positions[5]),
  makeLightSquare(positions[6]),
  makeDarkSquare(positions[7]),
];

const makeOddRow = (positions: Position[]): TBoardRow => [
  makeDarkSquare(positions[0]),
  makeLightSquare(positions[1]),
  makeDarkSquare(positions[2]),
  makeLightSquare(positions[3]),
  makeDarkSquare(positions[4]),
  makeLightSquare(positions[5]),
  makeDarkSquare(positions[6]),
  makeLightSquare(positions[7]),
];

export const board: TBoard = [
  makeEvenRow([
    Position.A8,
    Position.B8,
    Position.C8,
    Position.D8,
    Position.E8,
    Position.F8,
    Position.G8,
    Position.H8,
  ]),
  makeOddRow([
    Position.A7,
    Position.B7,
    Position.C7,
    Position.D7,
    Position.E7,
    Position.F7,
    Position.G7,
    Position.H7,
  ]),
  makeEvenRow([
    Position.A6,
    Position.B6,
    Position.C6,
    Position.D6,
    Position.E6,
    Position.F6,
    Position.G6,
    Position.H6,
  ]),
  makeOddRow([
    Position.A5,
    Position.B5,
    Position.C5,
    Position.D5,
    Position.E5,
    Position.F5,
    Position.G5,
    Position.H5,
  ]),
  makeEvenRow([
    Position.A4,
    Position.B4,
    Position.C4,
    Position.D4,
    Position.E4,
    Position.F4,
    Position.G4,
    Position.H4,
  ]),
  makeOddRow([
    Position.A3,
    Position.B3,
    Position.C3,
    Position.D3,
    Position.E3,
    Position.F3,
    Position.G3,
    Position.H3,
  ]),
  makeEvenRow([
    Position.A2,
    Position.B2,
    Position.C2,
    Position.D2,
    Position.E2,
    Position.F2,
    Position.G2,
    Position.H2,
  ]),
  makeOddRow([
    Position.A1,
    Position.B1,
    Position.C1,
    Position.D1,
    Position.E1,
    Position.F1,
    Position.G1,
    Position.H1,
  ]),
];
